<template>
    <v-dialog
        v-model="isProductBulkDialog"
        width="800px"
        @click:outside="init"
    >
    <v-card>
    <v-card-text>
    <div class="d-flex flex-wrap justify-center justify-md-space-between gap-4 mb-6">
      <div class="d-flex flex-column justify-center">
        <h4 class="text-h4">
          Upload SKU Images
        </h4>
        <template v-for="(errorItem, index) in warning">
            <li v-if="Object.keys(errorItem).length > 0" :key="index">
                <ul>
                    <li v-for="(messages, field) in errorItem" :key="field">
                        <span class="warning--text">{{ messages }}</span>
                        
                    </li>
                </ul>
            </li>
        </template>
      </div>

      <div class="d-flex gap-4 align-center flex-wrap">
        <v-btn
          outlined
          color="secondary"
          class="mr-2"
          @click="init"
        >
          Discard
        </v-btn>
        <v-btn
          outlined
          color="primary"
          :loading="loadProductData"
          @click="uploadImages"
          :disabled="!fileData.length || fileData.length > 15"
        >
          Upload Images
        </v-btn>
      </div>
    </div>

    <v-row>
        <v-col md="12">

            <!-- 👉 Product Image -->
            <v-card class="mb-6">
                <v-card-text>
                    <template #title>
                    Products Images
                    </template>
                    <template #append>
                    <div class="text-primary font-weight-medium cursor-pointer">
                        Add Media from URL
                    </div>
                    </template>
                </v-card-text>

                <v-card-text>
                    <div class="flex">
                        <div class="w-full h-auto relative">
                        <div
                            ref="dropZoneRef"
                        >
                            <div v-if="fileData.length === 0"
                            class="d-flex flex-column justify-center align-center gap-y-2 pa-2 drop-zone rounded cursor-pointer"
                            @click="() => openFile()"
                            >
                            <v-btn
                                oulined
                                color="secondary"
                                class="rounded"
                                size="30"
                            >
                                <v-icon
                                size="24"
                                >{{ icons.mdiTrayArrowUp }}</v-icon>
                            </v-btn>
                            <span class="text-h6">
                                Click to upload you product files here.
                            </span>

                            </div>

                            <div v-else class="drop-zone"
                            >
                                <v-row class="match-height w-100">
                                    <v-col
                                        cols="12"
                                        sm="4"
                                        v-for="(item, index) in fileData"
                                        :key="index"
                                    >
                                        <v-card >
                                        <v-card-text
                                            class="d-flex flex-column cursor-pointer"
                                            flat
                                            @click="editProduct(item.file.name)"
                                        >
                                            <v-img
                                            :src="`${item.url}`"
                                            contain
                                            width="200px"
                                            height="150px"
                                            class="w-100 mx-auto"
                                            />
                                            <div class="mt-2">
                                            <span class="clamp-text text-wrap">
                                                {{ item.file.name }}
                                            </span>
                                            <span>
                                                {{ item.file.size / 1000 }} KB
                                            </span>
                                            </div>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-select
                                            v-model="item.side"
                                            :items="imageSides"
                                            label="Side"
                                            placeholder="Select Side"
                                            outlined
                                            dense
                                            hide-details
                                            @click.stop
                                            >
                                            </v-select>
                                        </v-card-actions>
                                        <v-card-actions>
                                            <v-btn
                                            text
                                            @click.stop="fileData.splice(index, 1); warning = []"
                                            >
                                            Remove File
                                            </v-btn>
                                        </v-card-actions>
                                        </v-card>
                                    </v-col>
                                </v-row>

                            </div>
                        </div>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-col>

    </v-row></v-card-text>
  </v-card>
  <product
    :productDialog.sync="editDialog"
    :product="product"
    @save="saveProduct"
  >

  </product>
</v-dialog>

</template>

<script>

import { ref, onMounted, watch } from '@vue/composition-api'
import Product from '../product-editor/ProductInfo.vue'
import {
    mdiTrayArrowUp
} from '@mdi/js'

import useProduct from '../useProduct'

export default {
    components: {
        Product
    },
    props:{
        isProductBulkDialog: {
            type: Boolean,
            required:true
        }
    },
    setup(props, {emit}) {
        const imageSides = ref([
            {value:1, text:'FRONT'},
            {value:2, text:'BACK'},
            {value:3, text:'TOP'},
            {value:4, text:'BOTTOM'},
            {value:5, text:'LEFT'},
            {value:8, text:'RIGHT'},
            {value:11, text:'DETAIL'},
            {value:12, text:'OTHER'}])
        const fileData = ref([])
        const saveLoader = ref(false)
        const warning = ref('')
        const editDialog = ref(false)

        const product = ref({})

        const {
            addBulkProductImages,
            loadProductData,
            addProduct
        } = useProduct()

        const uploadImages = async () => {
            const resp = await addBulkProductImages(fileData)
            switch(resp.status) {
                case 201: 
                    let images = []
                    let warningMessage = []
                    // JSON.parse(JSON.stringify(fileData.value))
                    if (resp.data.length > 0) {
                        fileData.value.forEach((image, index) => {
                            const upc = getUPC(image.file.name)
                            if ((upc && !checkValueInArrayOfObjects(resp.data, upc))) {
                                images.push(image)
                            }
                        })

                        fileData.value = images
                    }

                    if (fileData.value.length > 0) warning.value = [{image:'Check UPC/EAN is correct on the image filename.'}]
                    else warning.value = []
                    break;
                case 400:
                    warning.value = resp.data
                    break;
                default:
                    break;
            }
            

        }

        const init = () => {
            fileData.value = []
            warning.value = []
            saveLoader.value = false
            emit('update:is-product-bulk-dialog', false)
        }

        const checkValueInArrayOfObjects = (array, valueToCheck) => {
            return array.some(obj => Object.values(obj).includes(valueToCheck));
        }

        const getUPC = (str) => {
            const parts = str.split('.');
            if (parts.length < 1) {
                return undefined; // Or handle the case where there's no second-to-last element
            }
            return parts[0];
        }

        const getSecondToLast = (str) => {
            const parts = str.split('.');
            if (parts.length < 2) {
                return undefined; // Or handle the case where there's no second-to-last element
            }
            return parts[parts.length - 2];
        }

        const openFile = () => {
            let input = document.createElement('input');
            input.type = 'file';
            input.multiple = true
            input.accept = 'image/png'
            input.onchange = _ => {
                // you can use this method to get file and perform respective operations
                let files = Array.from(input.files);
                 // --- NEW CODE: LIMIT TO 15 ---
                const MAX_LIMIT = 15;
                
                if (files.length > MAX_LIMIT) {
                    // 1. Alert the user via the warning ref
                    warning.value = [{image:`Maximum limit is ${MAX_LIMIT} images. Only the first ${MAX_LIMIT} have been selected.`}];
                    
                    // 2. Trim the array to the first 15 files
                    files = files.slice(0, MAX_LIMIT);
                } else {
                    // Reset warning if selection is valid
                    warning.value = [];
                }
                // -----------------------------

                fileData.value = []
                
                files.map(file => {
                    const inputFile = {
                        file
                    }
                    let reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        inputFile.url = reader.result
                        if(getSecondToLast(file.name) != undefined) {
                            inputFile.side = imageSides.value[getSecondToLast(file.name)-1]
                        }
                        fileData.value.push(inputFile)
                    }
                })
            };
            input.click();
        }

        const editProduct = (filename) => {
            const barcode = filename.split(".")[0]
            product.value = {}
            product.value['barcode'] = barcode
            product.value['barcode_type'] = 'UPC'

            editDialog.value = true
        }

        const saveProduct = async (sku) => {
            // const sku = JSON.parse(JSON.stringify(product.value))
            const resp = await addProduct(sku)
            editDialog.value = false
            warning.value = [{image:`Product ${sku.barcode} added successfully! Click Upload Images!`}]
        }

        return {
            saveLoader,
            init,
            uploadImages,
            imageSides,
            fileData,
            loadProductData,
            openFile,
            warning,
            editDialog,
            editProduct,
            product,
            saveProduct,
            icons: {
                mdiTrayArrowUp
            }
        }
    }

}
</script>

<style>

.drop-zone {
  border: 1px dashed rgba(var(--v-theme-on-surface), var(--v-border-opacity));
}
</style>